<template>
  <div class="featured-slider">
    <swiper
      class="featured-slider__slider"
      :modules="modules"
      :slides-per-view="1"
      :space-between="0"
      :autoplay="{
        delay: 5000,
      }"
      :speed="1000"
      :pagination="{ clickable: true }"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <!-- Dots need to align to the container so ie align to content edge below  -->
      <swiper-slide
        v-for="(slide, index) in featured"
        :key="index"
      >
        <div class="featured-slider__slide">
          <div
            class="featured-slider__image"
            :style="`background-image: url('${slide.image}');`"
          ></div>
          <div class="featured-slider__content">
            <div class="featured-slider__supertitle">
              {{ slide.supertitle }}
            </div>
            <a
              :href="slide.url.Url"
              :target="slide.url.Target"
              v-if="slide.url"
              class="featured-slider__title"
              >{{ slide.title }}</a
            >
            <div
              v-else
              class="featured-slider__title"
            >
              {{ slide.title }}
            </div>
            <div
              class="featured-slider__caption featured-slider__caption--desktop" v-html="slide.caption"
            ></div>
          </div>
          <div
            class="featured-slider__caption featured-slider__caption--mobile"  v-html="slide.caption"
          ></div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/bundle";

export default {
  props: ["featured"],
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
    };
    const onSlideChange = () => {
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination],
    };
  },
};
</script>
